import { useCompleteFragment } from '@eluve/apollo-client';
import { getUserName } from '@eluve/utils';

import { useAppointmentId } from './appointment.context';
import { appointmentDoctorInteractionFragment } from './operations';

export const useAppointmentDoctorName = () => {
  const appointmentId = useAppointmentId();

  const data = useCompleteFragment({
    fragment: appointmentDoctorInteractionFragment,
    key: { id: appointmentId },
    strict: false,
  });

  const doctor = data?.doctor_interaction?.user;

  return doctor
    ? getUserName({
        firstName: doctor.firstName,
        lastName: doctor.lastName,
      })
    : null;
};
